import gql from 'graphql-tag';

const GET_ADVERTISER_BEACONS = gql`
  query getAdvertiserBeacons($advertiserId: ID!, $dspType: String!, $transactionTags: String, $limit: Int) {
    advertiserBeacons(advertiserId: $advertiserId, dspType: $dspType, transactionTags: $transactionTags, limit: $limit) {
      beaconId
      name
      advertiserId
      beaconType
      beaconPlacement
      workflowStatus
      isValidated
      acceptedAction
      trackingMethod
      beaconJavascriptCode
    }
  }
`;

export default GET_ADVERTISER_BEACONS;